var Backbone, SortToggleView, ref,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = (ref = typeof window !== "undefined" && window !== null ? window.Backbone : void 0) != null ? ref : require('backbone');

SortToggleView = (function(superClass) {
  extend(SortToggleView, superClass);

  function SortToggleView() {
    return SortToggleView.__super__.constructor.apply(this, arguments);
  }

  SortToggleView.prototype.events = {
    'change': '_onChange'
  };

  SortToggleView.prototype._onChange = function() {
    return this.trigger('change:value', {
      sort: this.$el.val()
    });
  };

  return SortToggleView;

})(Backbone.View);

if (typeof module !== "undefined" && module !== null ? module.exports : void 0) {
  module.exports = SortToggleView;
} else {
  Modules.SortToggle.Views.SortToggle = SortToggleView;
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2dycG4tc29ydHMvZnJvbnRlbmQvdmlld3Mvc29ydF90b2dnbGUuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvYWRjYWJhbGxlcm8vbmFwaXN0cmFuby9idWlsZC8xNDkyNDY3OTc1Mzc5LTM3OTUyL3N0YWdpbmctMjAxNy4wNC4xN18yMi4xNS9nb29kcy9tb2R1bGVzL2dycG4tc29ydHMvZnJvbnRlbmQvdmlld3Mvc29ydF90b2dnbGUuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLElBQUEsNkJBQUE7RUFBQTs7O0FBQUEsUUFBQSx1R0FBOEIsT0FBQSxDQUFRLFVBQVI7O0FBRXhCOzs7Ozs7OzJCQUNKLE1BQUEsR0FDRTtJQUFBLFFBQUEsRUFBVSxXQUFWOzs7MkJBRUYsU0FBQSxHQUFXLFNBQUE7V0FDVCxJQUFDLENBQUEsT0FBRCxDQUFTLGNBQVQsRUFBeUI7TUFBQSxJQUFBLEVBQU0sSUFBQyxDQUFBLEdBQUcsQ0FBQyxHQUFMLENBQUEsQ0FBTjtLQUF6QjtFQURTOzs7O0dBSmdCLFFBQVEsQ0FBQzs7QUFPdEMsdURBQUcsTUFBTSxDQUFFLGdCQUFYO0VBQ0UsTUFBTSxDQUFDLE9BQVAsR0FBaUIsZUFEbkI7Q0FBQSxNQUFBO0VBR0UsT0FBTyxDQUFDLFVBQVUsQ0FBQyxLQUFLLENBQUMsVUFBekIsR0FBc0MsZUFIeEMifQ==
